import styled from 'styled-components';

import {colors} from 'theme';

export const AttachmentsLabel = styled.div`
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
`;

export const AttachmentDropzone = styled.div<{isDragActive: boolean}>`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 120px;
    padding: 20px;
    border: 1px dashed
        ${({isDragActive}) => (isDragActive ? colors.brandPrimary : colors.textMuted)};
    border-radius: 8px;
    background-color: ${({isDragActive}) => (isDragActive ? colors.brandLight : colors.white)};
    cursor: pointer;
    outline: none;
    transition: border-color 200ms ease, background-color 200ms ease;

    &:hover,
    &:focus-visible {
        border-color: ${colors.brandPrimary};
        background-color: ${colors.brandLight};
    }
`;

export const AttachmentDropzoneContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

export const AttachmentDropzoneText = styled.p`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 14px;
`;

export const AttachmentDropzoneAction = styled.span`
    color: ${colors.brandPrimary};
    font-weight: 600;
`;

export const AttachmentDropzoneHint = styled.span`
    color: ${colors.textSecondary};
    font-size: 12px;
`;

export const AttachmentFileList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 8px 0 0;
    padding: 0;
    list-style: none;
`;

export const AttachmentFileItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;
    padding: 0 12px;
    border: 1px solid ${colors.border};
    border-radius: 8px;
`;

export const AttachmentFileName = styled.span`
    min-width: 0;
    overflow: hidden;
    color: ${colors.textPrimary};
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
